import type { FormProps } from "antd";
import { Form } from "antd";

import BaseButton from "@/components/BaseButton";
import FlexContainer from "@/components/FlexContainer";

import { StyledInput } from "./Styled";

type FieldType = {
    username?: string;
};

function ChangePhoneForm() {
    const onFinish: FormProps<FieldType>["onFinish"] = (values) => {
        console.log("Success:", values);
    };

    const onFinishFailed: FormProps<FieldType>["onFinishFailed"] = (
        errorInfo,
    ) => {
        console.log("Failed:", errorInfo);
    };

    const handleSend = () => {};

    return (
        <>
            <Form
                name="login"
                style={{
                    width: "100%",
                    padding: "0 16px",
                }}
                initialValues={{ remember: true }}
                onFinish={onFinish}
                onFinishFailed={onFinishFailed}
                autoComplete="off"
            >
                <Form.Item<FieldType>
                    name="username"
                    label="Номер телефону"
                    style={{ marginBottom: "16px" }}
                >
                    <StyledInput placeholder="Телефон" />
                </Form.Item>
                <FlexContainer>
                    <BaseButton
                        type="primary"
                        htmlType="submit"
                        onClick={handleSend}
                    >
                        Відправити
                    </BaseButton>
                </FlexContainer>
            </Form>
        </>
    );
}

export default ChangePhoneForm;
